/**
 * Shallow `===` over every prop except `message`. Row memo comparators run this before any
 * message shortcut, so a changed callback or flag always re-renders the row even when its
 * message object is unchanged.
 */
export function sameOtherProps<P extends { message: unknown }>(prev: P, next: P): boolean {
  const keys = new Set([...Object.keys(prev), ...Object.keys(next)]) as Set<keyof P>;
  return [...keys].every((key) => key === 'message' || prev[key] === next[key]);
}
